export enum Permission {
  CREATE_MATTER = "create:matter",
  CREATE_MATTER_TEMPLATE = "create:matter_template",
  READ_MATTER_TEMPLATE = "read:matter_template",
  UPDATE_MATTER_TEMPLATE = "update:matter_template",
  READ_MATTER = "read:matter",
  UPDATE_MATTER = "update:matter",
  READ_CONFIG = "read:configuration",
  UPDATE_CONFIG = "update:configuration",
  IMPORT_REFERENCE_DATA = "import:reference_data",
  RATE_META_DATA = "rate:metadata",
  BETA_FEATURES = "beta:features",
  GPM_OVERRIDE = "gpm:override",
  GPM_SLIDER = "gpm:slider",
  TIMEKEEPER_MANAGER = "timekeeper:manager",
  BETA_ROI = "beta:roi",
}

export const PermissionToADMap = new Map<Permission, string>([
  [Permission.CREATE_MATTER, "VPD_Matter_Editor"],
  [Permission.READ_MATTER, "VPD_Matter_Editor"],
  [Permission.UPDATE_MATTER, "VPD_Matter_Editor"],
  [Permission.CREATE_MATTER_TEMPLATE, "VPD_Matter_Template_Editor"],
  [Permission.READ_MATTER_TEMPLATE, "VPD_Matter_Template_Editor"],
  [Permission.UPDATE_MATTER_TEMPLATE, "VPD_Matter_Template_Editor"],
  [Permission.READ_CONFIG, "VPD_Configuration_Editor"],
  [Permission.UPDATE_CONFIG, "VPD_Configuration_Editor"],
  [Permission.GPM_OVERRIDE, "VPD_Enable_GPM"],
  [Permission.GPM_SLIDER, "VPD_GPM_Slider"],
  [Permission.BETA_ROI, "VPD_Beta_ROI"],
]);

export const PermissionToDescription = new Map<Permission, string>([
  [Permission.CREATE_MATTER, "Create Matter"],
  [Permission.READ_MATTER, "Read Matter"],
  [Permission.UPDATE_MATTER, "Update Matter"],
  [Permission.CREATE_MATTER_TEMPLATE, "Create Matter Template"],
  [Permission.READ_MATTER_TEMPLATE, "Read Matter Template"],
  [Permission.UPDATE_MATTER_TEMPLATE, "Update Matter Template"],
  [Permission.READ_CONFIG, "Read Configuration"],
  [Permission.UPDATE_CONFIG, "Update Configuration"],
  [Permission.IMPORT_REFERENCE_DATA, "Import Reference Data"],
  [Permission.RATE_META_DATA, "Rate Meta Data"],
  [Permission.BETA_FEATURES, "Beta Features"],
  [Permission.GPM_OVERRIDE, "Enable GPM"],
  [Permission.GPM_SLIDER, "GPM Slider"],
  [Permission.BETA_ROI, "Beta ROI"],
]);

export type PermissionKey = keyof typeof Permission;

export const PermissionKeyByValue: Record<string, PermissionKey> = Object.freeze(
  Object.keys(Permission).reduce((map: any, key: string) => {
    map[Permission[key as PermissionKey]] = key;
    return map;
  }, {} as any)
);

export const ADGroupFromPermission = (permissions: Permission[] | Permission) => {
  if (!permissions) return [];
  const groups = Array.isArray(permissions) ? permissions : [permissions];
  return [...new Set(groups.map((p) => PermissionToADMap.get(p)).filter((g) => g))];
};

export function transformAuth0Permissions(values: string[]) {
  const permissions: Permission[] = [];
  for (const value of values) {
    if (value === null) continue;
    const key = PermissionKeyByValue[value];
    if (key) {
      permissions.push(Permission[PermissionKeyByValue[value]]);
    }
  }
  return permissions;
}
